import React, { useState } from "react";
import { Paper, Button, Box, Typography, Avatar } from "@mui/material";

const TittleComponent = ({ title }) => {
  const [showMoreTitle, setShowMoreTitle] = useState(false);
  return (
    <>
      <Typography component="p">
        {title.length > 70
          ? showMoreTitle
            ? "| " + title + " "
            : "| " + title.slice(0, 70) + "..."
          : "| " + title}
        {title.length > 70 && (
          <Button
            onClick={() => {
              if (showMoreTitle) {
                setShowMoreTitle(false);
              } else {
                setShowMoreTitle(true);
              }
            }}
            className="title-indicator"
          >
            {showMoreTitle ? "less" : "more"}
          </Button>
        )}
      </Typography>
    </>
  );
};

export default TittleComponent;
